import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { LDProvider } from 'launchdarkly-react-client-sdk';
import { LicenseInfo } from '@mui/x-license';
import { PersistGate } from 'redux-persist/integration/react';

import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import store from './redux';
import { getConfigProperty } from './core/EnvironmentConfig/EnvironmentConfig';
import { persistor } from './redux/store';

const licenseKey: string | undefined = process.env.REACT_APP_MUI_DATA_GRID_LICENSE_KEY;
licenseKey && LicenseInfo.setLicenseKey(licenseKey);

const launchDarklyKey: string | undefined = getConfigProperty('apiKey')['launchDarkly'];

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <React.StrictMode>
        <LDProvider clientSideID={launchDarklyKey || ''}>
          <App />
        </LDProvider>
      </React.StrictMode>
    </PersistGate>
  </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
